/**
 * The various URI Types.
 */
export const URITypeMap = {
    AD: 'ad',
    ALBUM: 'album',
    APPLICATION: 'application',
    ARTIST: 'artist',
    ARTIST_TOPLIST: 'artist-toplist',
    ARTIST_CONCERTS: 'artist-concerts',
    AUDIO: 'audio',
    AUDIO_FILE: 'audiofile',
    CACHED_FILES: 'cached-files',
    CANVAS: 'canvas',
    CHAT_MESSAGE: 'chat-message',
    COLLECTION: 'collection',
    COLLECTION_ALBUM: 'collection-album',
    COLLECTION_ARTIST: 'collection-artist',
    COLLECTION_MISSING_ALBUM: 'collection-missing-album',
    COLLECTION_TRACK_LIST: 'collectiontracklist',
    COMMENT: 'comment',
    CONCEPT: 'concept',
    CONCERT: 'concert',
    CONTEXT_GROUP: 'context-group',
    CONTRIBUTOR: 'contributor',
    COURSE: 'course',
    CULTURAL_MOMENT: 'cultural-moment',
    DAILY_MIX: 'dailymix',
    EMPTY: 'empty',
    EPISODE: 'episode',
    EXPRESSION: 'expression',
    FACEBOOK: 'facebook',
    FESTIVAL: 'festival',
    FOLDER: 'folder',
    FOLLOWERS: 'followers',
    FOLLOWING: 'following',
    GENRE: 'genre',
    IMAGE: 'image',
    INBOX: 'inbox',
    INTERRUPTION: 'interruption',
    JAM: 'jam',
    LESSON: 'lesson',
    LIBRARY: 'library',
    LIVE: 'live',
    LOCAL_ALBUM: 'local-album',
    LOCAL_ARTIST: 'local-artist',
    /**
     * @deprecated - Use `LOCAL_TRACK` instead.
     */
    LOCAL: 'local',
    LOCAL_TRACK: 'local',
    MEDIA: 'media',
    MERCHHUB: 'merchhub',
    MERCH: 'merch',
    MOSAIC: 'mosaic',
    PLAYLIST: 'playlist',
    PLAYLIST_V2: 'playlist-v2', // Only used for URI classification, not a fragment
    POLL: 'poll',
    PRERELEASE: 'prerelease',
    PRESENTS: 'presents',
    PROFILE: 'profile',
    PROMOTER: 'promoter',
    PROMOTION: 'promotion',
    PUBLISHED_ROOTLIST: 'published-rootlist',
    RADIO: 'radio',
    RESPONSE: 'response',
    ROOM: 'room',
    ROOTLIST: 'rootlist',
    SEARCH: 'search',
    S4A_THIRD_PARTY: 's4a-third-party',
    SHOW: 'show',
    SITE: 'site',
    SOCIAL_SESSION: 'socialsession',
    SPECIAL: 'special',
    STARRED: 'starred',
    STATION: 'station',
    SUPPLEMENTARY_MATERIAL: 'supplementarymaterial',
    TEMP_PLAYLIST: 'temp-playlist',
    TOPLIST: 'toplist',
    TOUR: 'tour',
    TRACK: 'track',
    TRACKSET: 'trackset',
    UNKNOWN: 'unknown',
    USER_TOPLIST: 'user-toplist',
    USER_TOP_TRACKS: 'user-top-tracks',
    QUEUE: 'queue',
    QUESTION: 'question',
    VENUE: 'venue',
    VIDEO: 'video',
};
//# sourceMappingURL=uri_type.js.map